import {createAction} from 'redux-actions';

import {
  getMessages,
  personalInformationEndpoint
} from '../../../utils/api/api-endpoint-dictionary';
import callApi from '../../../utils/api/axios';

const USER_PERSONAL_INFORMATION = 'USER_PERSONAL_INFORMATION';
const GET_USER_MESSAGE = 'GET_USER_MESSAGE';

export default function personalInformation(
  state = {
    isLoading: false,
    normalizing: false,
    isLoaded: false,
    normalized: false,
    hasFailed: false,
    unableToNormalize: false,
    normalizedAddress: null,
    messagesNumber: 0,
    data: {}
  },
  { payload, type }
) {
  switch (type) {
    case `${USER_PERSONAL_INFORMATION}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true
      };
    case `${USER_PERSONAL_INFORMATION}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        data: payload.data
      };

    case `${USER_PERSONAL_INFORMATION}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true
      };
    case `${GET_USER_MESSAGE}_FULFILLED`: {
      const num = payload.data.filter((message) => !message.viewed).length;
      return {
        ...state,
        messagesNumber: num
      }
    }
    default:
      return state;
  }
}

export const getPersonalInformation = () => {
  return (dispatch) => {
    const action = createAction(USER_PERSONAL_INFORMATION)(
      callApi(personalInformationEndpoint)
    );
    return dispatch(action);
  };
};

export const getUserMessages = () => {
  return (dispatch) => {
    const action = createAction(GET_USER_MESSAGE)(
      callApi(getMessages)
    );
    return dispatch(action);
  };
};

